<div class="mc-avatar-tooltip-container" matTooltip="Flare Desktop" [matTooltipDisabled]="disabledTooltip">
  <div *ngIf="showAvatar" class="mc-avatar-container">
    <img alt="Flare Desktop Logo" class="mc-avatar-image" src="assets/images/madcap-flare-logo.svg">
  </div>
  <span *ngIf="showName" class="mc-avatar-name">Flare Desktop</span>
</div>